export const STRING_DELIMITER = '###';

export const MOBILE_BOTTOM_SHEET_BREAKPOINT = 767;
